import * as React from 'react';
import { cn } from '../lib/utils';

function Carousel({ className, children, ...props }: React.ComponentProps<'ul'>) {
	return (
		// Plain `pan-x` froze the page under a vertical swipe; it computes to `manipulation`, which is fine.
		<ul className={cn('carousel flex w-full gap-4 px-6 [touch-action:pan-x_pan-y_pinch-zoom]', className)} {...props}>
			{children}
		</ul>
	);
}

/** Measured between the first two children, so it holds for one slide per frame or several, at any gap. */
function carouselStep(el: HTMLUListElement) {
	const [first, second] = [el.children[0], el.children[1]] as (HTMLElement | undefined)[];
	return first && second ? second.offsetLeft - first.offsetLeft : el.clientWidth;
}

function CarouselItem({ className, ...props }: React.ComponentProps<'li'>) {
	return <li className={cn('shrink-0', className)} {...props} />;
}

export { Carousel, CarouselItem, carouselStep };
